export default __webpack_public_path__ + "static/media/siemens.4aa8efa4.png";